import * as React from 'react';
import { prefixer } from 'stylis';
import rtlPlugin from '@mui/stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, stylis: { prefixer }, "@mui/stylis-plugin-rtl": rtlPlugin, "@emotion/react": { CacheProvider }, "@emotion/cache": createCache, "@mui/material/styles": { styled }, "@mui/material/Box": Box, "@mui/material/FormControlLabel": FormControlLabel, "@mui/material/Switch": Switch } } });
export default ClientProvider;
